import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ZoomOutIcon = withSvgIcon(
    <g>
        <path d="M25.7 224.7h450v50h-450z" />
    </g>
);
